import { useTranslation } from 'react-i18next';
import { Button, Modal, Text } from '@shared/widgets';

interface ISuccessDeletedUserModal {
  show: boolean;
  onClose: () => void;
}

export const SuccessDeletedUserModal = (props: ISuccessDeletedUserModal) => {
  const { t } = useTranslation('userManagement');

  return (
    <Modal isOpen={props.show} onClose={props.onClose} title='' setAutoCloseSeconds={5}>
      <div>
        <Text size='xl'>{t('modals.delete.description')}</Text>
        <Button color='primary' className='mt-8' fullWidth onClick={props.onClose}>
          {t('modals.delete.button')}
        </Button>
      </div>
    </Modal>
  );
};
